module.exports = {
	"v": "4.10.2",
	"fr": 29.9700012207031,
	"ip": 0,
	"op": 90.0000036657751,
	"w": 500,
	"h": 700,
	"nm": "final 2",
	"ddd": 0,
	"assets": [
		{
			"id": "comp_0",
			"layers": [
				{
					"ddd": 0,
					"ind": 1,
					"ty": 4,
					"nm": "mini triangle/illustrations_app_mod Outlines",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								854,
								402,
								0
							],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [
								119.5,
								162.5,
								0
							],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-0.04,
													-56.388
												],
												[
													0.04,
													56.388
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tm",
									"s": {
										"a": 0,
										"k": 100,
										"ix": 1
									},
									"e": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": [
														0.833
													],
													"y": [
														0.833
													]
												},
												"o": {
													"x": [
														0.167
													],
													"y": [
														0.167
													]
												},
												"n": [
													"0p833_0p833_0p167_0p167"
												],
												"t": 1,
												"s": [
													0
												],
												"e": [
													100
												]
											},
											{
												"t": 58.0000023623884
											}
										],
										"ix": 2
									},
									"o": {
										"a": 0,
										"k": 0,
										"ix": 3
									},
									"m": 1,
									"ix": 2,
									"nm": "Trim Paths 1",
									"mn": "ADBE Vector Filter - Trim",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.922000002394,
											0.328999986836,
											0.141000007181,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"d": [
										{
											"n": "d",
											"nm": "dash",
											"v": {
												"a": 0,
												"k": 8,
												"ix": 1
											}
										},
										{
											"n": "g",
											"nm": "gap",
											"v": {
												"a": 0,
												"k": 12,
												"ix": 2
											}
										},
										{
											"n": "o",
											"nm": "offset",
											"v": {
												"a": 0,
												"k": 0,
												"ix": 7
											}
										}
									],
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											215.375,
											267.563
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": [
														0.833
													],
													"y": [
														0.833
													]
												},
												"o": {
													"x": [
														0.167
													],
													"y": [
														0.167
													]
												},
												"n": [
													"0p833_0p833_0p167_0p167"
												],
												"t": 0,
												"s": [
													100
												],
												"e": [
													100
												]
											},
											{
												"t": 59.0000024031193
											}
										],
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 3,
							"cix": 2,
							"ix": 1,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													0.001,
													-16.791
												],
												[
													-0.596,
													16.791
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													0.001,
													-16.791
												],
												[
													20.342,
													4.845
												],
												[
													-0.596,
													16.791
												],
												[
													-20.342,
													4.845
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "mm",
									"mm": 1,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.922000002394,
											0.328999986836,
											0.141000007181,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "gr",
									"it": [
										{
											"ind": 0,
											"ty": "sh",
											"ix": 1,
											"ks": {
												"a": 0,
												"k": {
													"i": [
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														]
													],
													"o": [
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														]
													],
													"v": [
														[
															20.423,
															0
														],
														[
															-0.242,
															-11.947
														],
														[
															-20.423,
															-0.161
														],
														[
															-0.564,
															11.947
														]
													],
													"c": true
												},
												"ix": 2
											},
											"nm": "Path 1",
											"mn": "ADBE Vector Shape - Group",
											"hd": false
										},
										{
											"ty": "st",
											"c": {
												"a": 0,
												"k": [
													0.922000002394,
													0.328999986836,
													0.141000007181,
													1
												],
												"ix": 3
											},
											"o": {
												"a": 0,
												"k": 100,
												"ix": 4
											},
											"w": {
												"a": 0,
												"k": 1,
												"ix": 5
											},
											"lc": 1,
											"lj": 1,
											"ml": 10,
											"nm": "Stroke 1",
											"mn": "ADBE Vector Graphic - Stroke",
											"hd": false
										},
										{
											"ty": "tr",
											"p": {
												"a": 0,
												"k": [
													-0.239,
													5.156
												],
												"ix": 2
											},
											"a": {
												"a": 0,
												"k": [
													0,
													0
												],
												"ix": 1
											},
											"s": {
												"a": 0,
												"k": [
													100,
													100
												],
												"ix": 3
											},
											"r": {
												"a": 0,
												"k": 0,
												"ix": 6
											},
											"o": {
												"a": 0,
												"k": 100,
												"ix": 7
											},
											"sk": {
												"a": 0,
												"k": 0,
												"ix": 4
											},
											"sa": {
												"a": 0,
												"k": 0,
												"ix": 5
											},
											"nm": "Transform"
										}
									],
									"nm": "Group 3",
									"np": 2,
									"cix": 2,
									"ix": 5,
									"mn": "ADBE Vector Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											215.335,
											173.976
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": [
														0.833,
														0.833
													],
													"y": [
														0.833,
														0.833
													]
												},
												"o": {
													"x": [
														0.167,
														0.167
													],
													"y": [
														0.167,
														0.167
													]
												},
												"n": [
													"0p833_0p833_0p167_0p167",
													"0p833_0p833_0p167_0p167"
												],
												"t": 0,
												"s": [
													100,
													100
												],
												"e": [
													125,
													125
												]
											},
											{
												"i": {
													"x": [
														0.833,
														0.833
													],
													"y": [
														0.833,
														0.833
													]
												},
												"o": {
													"x": [
														0.167,
														0.167
													],
													"y": [
														0.167,
														0.167
													]
												},
												"n": [
													"0p833_0p833_0p167_0p167",
													"0p833_0p833_0p167_0p167"
												],
												"t": 11,
												"s": [
													125,
													125
												],
												"e": [
													100,
													100
												]
											},
											{
												"t": 20.0000008146167
											}
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 2",
							"np": 5,
							"cix": 2,
							"ix": 2,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-0.04,
													-67.41
												],
												[
													0.04,
													67.41
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tm",
									"s": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": [
														0.399
													],
													"y": [
														0.591
													]
												},
												"o": {
													"x": [
														0.167
													],
													"y": [
														0.167
													]
												},
												"n": [
													"0p399_0p591_0p167_0p167"
												],
												"t": 0,
												"s": [
													0
												],
												"e": [
													99.15
												]
											},
											{
												"t": 56.0000022809268
											}
										],
										"ix": 1
									},
									"e": {
										"a": 0,
										"k": 100,
										"ix": 2
									},
									"o": {
										"a": 0,
										"k": 0,
										"ix": 3
									},
									"m": 1,
									"ix": 2,
									"nm": "Trim Paths 1",
									"mn": "ADBE Vector Filter - Trim",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.26699999641,
											0.779999976065,
											0.957000014361,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"d": [
										{
											"n": "d",
											"nm": "dash",
											"v": {
												"a": 0,
												"k": 8,
												"ix": 1
											}
										},
										{
											"n": "g",
											"nm": "gap",
											"v": {
												"a": 0,
												"k": 12,
												"ix": 2
											}
										},
										{
											"n": "o",
											"nm": "offset",
											"v": {
												"a": 0,
												"k": 0,
												"ix": 7
											}
										}
									],
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											22.884,
											123.519
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": [
														0.896
													],
													"y": [
														0.252
													]
												},
												"o": {
													"x": [
														0.167
													],
													"y": [
														0.167
													]
												},
												"n": [
													"0p896_0p252_0p167_0p167"
												],
												"t": 0,
												"s": [
													100
												],
												"e": [
													0
												]
											},
											{
												"t": 59.0000024031193
											}
										],
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 4",
							"np": 3,
							"cix": 2,
							"ix": 3,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													0,
													-16.791
												],
												[
													-0.596,
													16.791
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													0,
													-16.791
												],
												[
													20.343,
													4.844
												],
												[
													-0.596,
													16.791
												],
												[
													-20.343,
													4.844
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "mm",
									"mm": 1,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.26699999641,
											0.779999976065,
											0.957000014361,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "gr",
									"it": [
										{
											"ind": 0,
											"ty": "sh",
											"ix": 1,
											"ks": {
												"a": 0,
												"k": {
													"i": [
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														]
													],
													"o": [
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														]
													],
													"v": [
														[
															20.424,
															0
														],
														[
															-0.242,
															-11.947
														],
														[
															-20.424,
															-0.161
														],
														[
															-0.565,
															11.947
														]
													],
													"c": true
												},
												"ix": 2
											},
											"nm": "Path 1",
											"mn": "ADBE Vector Shape - Group",
											"hd": false
										},
										{
											"ty": "st",
											"c": {
												"a": 0,
												"k": [
													0.26699999641,
													0.779999976065,
													0.957000014361,
													1
												],
												"ix": 3
											},
											"o": {
												"a": 0,
												"k": 100,
												"ix": 4
											},
											"w": {
												"a": 0,
												"k": 1,
												"ix": 5
											},
											"lc": 1,
											"lj": 1,
											"ml": 10,
											"nm": "Stroke 1",
											"mn": "ADBE Vector Graphic - Stroke",
											"hd": false
										},
										{
											"ty": "fl",
											"c": {
												"a": 0,
												"k": [
													0.136999990426,
													0.122000002394,
													0.125,
													1
												],
												"ix": 4
											},
											"o": {
												"a": 0,
												"k": 100,
												"ix": 5
											},
											"r": 1,
											"nm": "Fill 1",
											"mn": "ADBE Vector Graphic - Fill",
											"hd": false
										},
										{
											"ty": "tr",
											"p": {
												"a": 0,
												"k": [
													0.197,
													4.443
												],
												"ix": 2
											},
											"a": {
												"a": 0,
												"k": [
													0,
													0
												],
												"ix": 1
											},
											"s": {
												"a": 0,
												"k": [
													100,
													100
												],
												"ix": 3
											},
											"r": {
												"a": 0,
												"k": 0,
												"ix": 6
											},
											"o": {
												"a": 0,
												"k": 100,
												"ix": 7
											},
											"sk": {
												"a": 0,
												"k": 0,
												"ix": 4
											},
											"sa": {
												"a": 0,
												"k": 0,
												"ix": 5
											},
											"nm": "Transform"
										}
									],
									"nm": "Group 6",
									"np": 3,
									"cix": 2,
									"ix": 5,
									"mn": "ADBE Vector Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											22.843,
											19.291
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": [
														0.833,
														0.833
													],
													"y": [
														0.833,
														0.833
													]
												},
												"o": {
													"x": [
														0.167,
														0.167
													],
													"y": [
														0.167,
														0.167
													]
												},
												"n": [
													"0p833_0p833_0p167_0p167",
													"0p833_0p833_0p167_0p167"
												],
												"t": 0,
												"s": [
													100,
													100
												],
												"e": [
													125,
													125
												]
											},
											{
												"i": {
													"x": [
														0.833,
														0.833
													],
													"y": [
														0.833,
														0.833
													]
												},
												"o": {
													"x": [
														0.167,
														0.167
													],
													"y": [
														0.167,
														0.167
													]
												},
												"n": [
													"0p833_0p833_0p167_0p167",
													"0p833_0p833_0p167_0p167"
												],
												"t": 11,
												"s": [
													125,
													125
												],
												"e": [
													100,
													100
												]
											},
											{
												"t": 20.0000008146167
											}
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 5",
							"np": 5,
							"cix": 2,
							"ix": 4,
							"mn": "ADBE Vector Group",
							"hd": false
						}
					],
					"ip": 0,
					"op": 90.0000036657751,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 2,
					"ty": 4,
					"nm": "last triangle/illustrations_app_mod Outlines",
					"sr": 1,
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											1.001
										]
									},
									"o": {
										"x": [
											0.337
										],
										"y": [
											0.005
										]
									},
									"n": [
										"0p833_1p001_0p337_0p005"
									],
									"t": 37,
									"s": [
										0
									],
									"e": [
										99.35
									]
								},
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0
										]
									},
									"n": [
										"0p833_1_0p167_0"
									],
									"t": 58,
									"s": [
										99.35
									],
									"e": [
										0
									]
								},
								{
									"t": 73.000002973351
								}
							],
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								1112,
								816,
								0
							],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [
								23,
								19.5,
								0
							],
							"ix": 1
						},
						"s": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.833,
											0.833,
											0.833
										],
										"y": [
											0.833,
											0.833,
											0.833
										]
									},
									"o": {
										"x": [
											0.167,
											0.167,
											0.167
										],
										"y": [
											0.167,
											0.167,
											0.167
										]
									},
									"n": [
										"0p833_0p833_0p167_0p167",
										"0p833_0p833_0p167_0p167",
										"0p833_0p833_0p167_0p167"
									],
									"t": 42,
									"s": [
										100,
										100,
										100
									],
									"e": [
										125,
										125,
										100
									]
								},
								{
									"i": {
										"x": [
											0.833,
											0.833,
											0.833
										],
										"y": [
											0.833,
											0.833,
											0.833
										]
									},
									"o": {
										"x": [
											0.167,
											0.167,
											0.167
										],
										"y": [
											0.167,
											0.167,
											0.167
										]
									},
									"n": [
										"0p833_0p833_0p167_0p167",
										"0p833_0p833_0p167_0p167",
										"0p833_0p833_0p167_0p167"
									],
									"t": 52,
									"s": [
										125,
										125,
										100
									],
									"e": [
										100,
										100,
										100
									]
								},
								{
									"t": 73.000002973351
								}
							],
							"ix": 6
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													0,
													-16.791
												],
												[
													-0.596,
													16.791
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													0,
													-16.791
												],
												[
													20.342,
													4.844
												],
												[
													-0.596,
													16.791
												],
												[
													-20.342,
													4.844
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "mm",
									"mm": 1,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.922000002394,
											0.328999986836,
											0.141000007181,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											22.843,
											19.29
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 4,
							"cix": 2,
							"ix": 1,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													20.423,
													0
												],
												[
													-0.242,
													-11.947
												],
												[
													-20.423,
													-0.161
												],
												[
													-0.565,
													11.947
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.922000002394,
											0.328999986836,
											0.141000007181,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											22.923,
											24.295
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 2",
							"np": 2,
							"cix": 2,
							"ix": 2,
							"mn": "ADBE Vector Group",
							"hd": false
						}
					],
					"ip": 0,
					"op": 90.0000036657751,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 3,
					"ty": 4,
					"nm": "Layer 25/illustrations_app_mod Outlines",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								1114,
								488,
								0
							],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [
								38,
								280.5,
								0
							],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													36.826,
													93.589
												],
												[
													36.826,
													560.071
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "tm",
									"s": {
										"a": 0,
										"k": 0,
										"ix": 1
									},
									"e": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": [
														0.833
													],
													"y": [
														0.833
													]
												},
												"o": {
													"x": [
														0.167
													],
													"y": [
														0.167
													]
												},
												"n": [
													"0p833_0p833_0p167_0p167"
												],
												"t": -14,
												"s": [
													0
												],
												"e": [
													100
												]
											},
											{
												"t": 43.0000017514259
											}
										],
										"ix": 2
									},
									"o": {
										"a": 0,
										"k": 0,
										"ix": 3
									},
									"m": 1,
									"ix": 2,
									"nm": "Trim Paths 1",
									"mn": "ADBE Vector Filter - Trim",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.922000002394,
											0.328999986836,
											0.141000007181,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"d": [
										{
											"n": "d",
											"nm": "dash",
											"v": {
												"a": 0,
												"k": 8,
												"ix": 1
											}
										},
										{
											"n": "g",
											"nm": "gap",
											"v": {
												"a": 0,
												"k": 12,
												"ix": 2
											}
										},
										{
											"n": "o",
											"nm": "offset",
											"v": {
												"a": 0,
												"k": 0,
												"ix": 7
											}
										}
									],
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": [
														0.833
													],
													"y": [
														0.833
													]
												},
												"o": {
													"x": [
														0.167
													],
													"y": [
														0.167
													]
												},
												"n": [
													"0p833_0p833_0p167_0p167"
												],
												"t": 1,
												"s": [
													100
												],
												"e": [
													0
												]
											},
											{
												"t": 58.0000023623884
											}
										],
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 3,
							"cix": 2,
							"ix": 1,
							"mn": "ADBE Vector Group",
							"hd": false
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													0.001,
													-29.157
												],
												[
													-1.034,
													29.157
												]
											],
											"c": false
										},
										"ix": 2
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													0.001,
													-29.157
												],
												[
													35.325,
													8.41
												],
												[
													-1.034,
													29.157
												],
												[
													-35.325,
													8.41
												]
											],
											"c": true
										},
										"ix": 2
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group",
									"hd": false
								},
								{
									"ty": "mm",
									"mm": 1,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.922000002394,
											0.328999986836,
											0.141000007181,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 1,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 10,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "gr",
									"it": [
										{
											"ind": 0,
											"ty": "sh",
											"ix": 1,
											"ks": {
												"a": 0,
												"k": {
													"i": [
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														]
													],
													"o": [
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														],
														[
															0,
															0
														]
													],
													"v": [
														[
															35.465,
															-0.001
														],
														[
															-0.42,
															-20.746
														],
														[
															-35.465,
															-0.281
														],
														[
															-0.98,
															20.746
														]
													],
													"c": true
												},
												"ix": 2
											},
											"nm": "Path 1",
											"mn": "ADBE Vector Shape - Group",
											"hd": false
										},
										{
											"ty": "st",
											"c": {
												"a": 0,
												"k": [
													0.922000002394,
													0.328999986836,
													0.141000007181,
													1
												],
												"ix": 3
											},
											"o": {
												"a": 0,
												"k": 100,
												"ix": 4
											},
											"w": {
												"a": 0,
												"k": 1,
												"ix": 5
											},
											"lc": 1,
											"lj": 1,
											"ml": 10,
											"nm": "Stroke 1",
											"mn": "ADBE Vector Graphic - Stroke",
											"hd": false
										},
										{
											"ty": "fl",
											"c": {
												"a": 0,
												"k": [
													0.13300000359,
													0.13300000359,
													0.156999999402,
													1
												],
												"ix": 4
											},
											"o": {
												"a": 0,
												"k": 100,
												"ix": 5
											},
											"r": 1,
											"nm": "Fill 1",
											"mn": "ADBE Vector Graphic - Fill",
											"hd": false
										},
										{
											"ty": "tr",
											"p": {
												"a": 0,
												"k": [
													-0.099,
													8.444
												],
												"ix": 2
											},
											"a": {
												"a": 0,
												"k": [
													0,
													0
												],
												"ix": 1
											},
											"s": {
												"a": 0,
												"k": [
													100,
													100
												],
												"ix": 3
											},
											"r": {
												"a": 0,
												"k": 0,
												"ix": 6
											},
											"o": {
												"a": 0,
												"k": 100,
												"ix": 7
											},
											"sk": {
												"a": 0,
												"k": 0,
												"ix": 4
											},
											"sa": {
												"a": 0,
												"k": 0,
												"ix": 5
											},
											"nm": "Transform"
										}
									],
									"nm": "Group 3",
									"np": 3,
									"cix": 2,
									"ix": 5,
									"mn": "ADBE Vector Group",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											37.825,
											31.657
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": [
														0.833,
														0.833
													],
													"y": [
														0.833,
														0.833
													]
												},
												"o": {
													"x": [
														0.167,
														0.167
													],
													"y": [
														0.167,
														0.167
													]
												},
												"n": [
													"0p833_0p833_0p167_0p167",
													"0p833_0p833_0p167_0p167"
												],
												"t": 5,
												"s": [
													100,
													100
												],
												"e": [
													125,
													125
												]
											},
											{
												"i": {
													"x": [
														0.833,
														0.833
													],
													"y": [
														0.833,
														0.833
													]
												},
												"o": {
													"x": [
														0.167,
														0.167
													],
													"y": [
														0.167,
														0.167
													]
												},
												"n": [
													"0p833_0p833_0p167_0p167",
													"0p833_0p833_0p167_0p167"
												],
												"t": 10,
												"s": [
													125,
													125
												],
												"e": [
													100,
													100
												]
											},
											{
												"t": 16.0000006516934
											}
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 2",
							"np": 5,
							"cix": 2,
							"ix": 2,
							"mn": "ADBE Vector Group",
							"hd": false
						}
					],
					"ip": 0,
					"op": 90.0000036657751,
					"st": 0,
					"bm": 0
				}
			]
		}
	],
	"layers": [
		{
			"ddd": 0,
			"ind": 1,
			"ty": 0,
			"nm": "final",
			"refId": "comp_0",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						272,
						360,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						960,
						540,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"w": 1920,
			"h": 1080,
			"ip": 0,
			"op": 90.0000036657751,
			"st": 0,
			"bm": 0
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/app-modernization/animations/legacy.json
// module id = 1361
// module chunks = 0